import { httpClient } from '@/Common/api/http_client';

// =========================================
// Merchant Specific APIs starts
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllSuppliedGoods() {
  return httpClient.get('/merchant/supplied-goods');
}

/**
 *
 * @param suppliedGoodId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getSuppliedGood(suppliedGoodId) {
  return httpClient.get(`/merchant/supplied-goods/${suppliedGoodId}`);
}

/**
 *
 * @param suppliedGoodId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteSuppliedGood(suppliedGoodId) {
  return httpClient.delete(`/merchant/supplied-goods/${suppliedGoodId}`);
}

/**
 *
 * @param suppliedGoodId
 * @param suppliedGood
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateSuppliedGood(suppliedGoodId, suppliedGood) {
  return httpClient.put(`/merchant/supplied-goods/${suppliedGoodId}`, suppliedGood);
}

/**
 *
 * @param suppliedGood
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newSuppliedGood(suppliedGood) {
  return httpClient.post('/merchant/supplied-goods', suppliedGood);
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getAllSupplies() {
  return httpClient.get('/merchant/supplies');
}

/**
 *
 * @param supplyId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getSupply(supplyId) {
  return httpClient.get(`/merchant/supplies/${supplyId}`);
}

/**
 *
 * @param supplyId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteSupply(supplyId) {
  return httpClient.delete(`/merchant/supplies/${supplyId}`);
}

/**
 *
 * @param supplyId
 * @param supply
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateSupply(supplyId, supply) {
  return httpClient.put(`/merchant/supplies/${supplyId}`, supply);
}

/**
 *
 * @param supply
 * @returns {Promise<AxiosResponse<T>>}
 */
export function newSupply(supply) {
  return httpClient.post('/merchant/supplies', supply);
}
